import { USER_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
        path: "/super-admin/user",
        name: "super-admin-user",
        component: () => import("@/views/super-admin/user/UserView.vue"),
        meta: {
          gate: USER_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Super Admin User",
          layout: "super-admin",
        },
      },
  ];
  